var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';
var CustomErrorHandler = /** @class */ (function (_super) {
    __extends(CustomErrorHandler, _super);
    function CustomErrorHandler(errorTracking, config, platformId, request, response) {
        var _this = _super.call(this) || this;
        _this.errorTracking = errorTracking;
        _this.config = config;
        _this.platformId = platformId;
        _this.request = request;
        _this.response = response;
        _this.isBrowser = isPlatformBrowser(_this.platformId);
        return _this;
    }
    CustomErrorHandler.prototype.handleError = function (value) {
        // Backport of https://github.com/angular/angular/pull/31443 to unwrap
        // unhandled Promises
        // FIXME: remove when https://github.com/angular/angular/pull/31443 has
        // landed & we've upgraded.
        var error;
        if (value.rejection &&
            (value.rejection instanceof Error || value.rejection.message)) {
            error = value.rejection;
        }
        else {
            error = value;
        }
        // When on the server, abort & return a 500
        if (isPlatformServer(this.platformId)) {
            // The Angular Router currently throws on URLs with scripts tags or
            // invalid characters
            // See https://github.com/angular/angular/issues/21032
            if (error.message.includes('Error: Cannot match any routes. URL Segment: ')) {
                this.response.status(400);
            }
            else {
                this.response.status(500);
            }
            this.request._SSR_handleError(error);
            return;
        }
        // When on the browser, report to Sentry
        // We don't log backend errors in Sentry as there are already logged in
        // Kibana
        if (!(error instanceof HttpErrorResponse)) {
            if (error instanceof Error) {
                this.errorTracking.captureException(error);
            }
            else {
                this.errorTracking.captureMessage(error.message || error);
            }
        }
        if (error instanceof HttpErrorResponse &&
            error.error &&
            error.error.error &&
            error.error.error.code &&
            error.error.request_id &&
            this.config.kibanaBaseUrl) {
            console.error((error.error.error.code + ": " + this.config.kibanaBaseUrl + "/app/kibana#/discover?_g=(time:(from:now-3d))&_a=(query:(language:lucene,query:'request_id:" + error.error.request_id + "'))")
                .replace(/\(/g, '%28')
                .replace(/\)/g, '%29'));
        }
        _super.prototype.handleError.call(this, error);
    };
    return CustomErrorHandler;
}(ErrorHandler));
export { CustomErrorHandler };
